import React from 'react';
import './Servicios.css'; // CSS externo para estilos
import { motion } from 'framer-motion';

const servicios = [
  {
    icon: 'fas fa-screwdriver-wrench',
    titulo: 'Mantenimiento y Montaje de Equipos',
    descripcion:
      'Armado y configuración de ordenadores a medida, limpieza física de componentes, cambio de pasta térmica, eliminación de malware, formateo e instalación de sistemas operativos, mejora de rendimiento, sustitución de piezas defectuosas y asesoramiento personalizado para upgrades.',
  },
  {
    icon: 'fas fa-mobile-screen-button',
    titulo: 'Reparación de Dispositivos',
    descripcion:
      'Diagnóstico y reparación de fallos en ordenadores, tablets, móviles y consolas. Sustitución de pantallas, baterías, conectores, placas, reparación de sobrecalentamiento, problemas de software, recuperación tras caídas o líquidos y desbloqueo de dispositivos.',
  },
  {
    icon: 'fas fa-video',
    titulo: 'Montaje de Cámaras de Videovigilancia',
    descripcion:
      'Instalación de cámaras IP o analógicas, configuración de grabadores (DVR/NVR), visualización remota por app, mantenimiento del sistema, ampliaciones, cableado estructurado y asesoramiento en seguridad para viviendas y empresas.',
  },
  {
    icon: 'fas fa-database',
    titulo: 'Recuperación de Datos',
    descripcion:
      'Recuperación de archivos eliminados accidentalmente, datos perdidos por fallo lógico o físico en discos duros, SSD, memorias USB, tarjetas SD, móviles y servidores. Diagnóstico gratuito y privacidad garantizada.',
  },
  {
    icon: 'fas fa-headset',
    titulo: 'Soporte Técnico Remoto y Presencial',
    descripcion:
      'Asistencia para instalación de software, resolución de errores, configuración de correo, redes domésticas, periféricos, antivirus, copias de seguridad, mantenimiento programado y soporte para usuarios domésticos y empresas, vía remota o en domicilio.',
  },
  {
    icon: 'fas fa-network-wired',
    titulo: 'Redes y Conectividad',
    descripcion:
      'Diseño e instalación de redes cableadas o inalámbricas, configuración de routers, switches y puntos de acceso, cableado estructurado, auditoría de red, solución de problemas de conectividad, ampliación de cobertura Wi-Fi y securización mediante firewall y control de acceso.',
  },
  {
    icon: 'fas fa-lock',
    titulo: 'Ciberseguridad para Usuarios y PYMEs',
    descripcion:
      'Implementación de soluciones antivirus, antimalware y firewall. Auditoría de seguridad, prevención de fugas de datos, gestión de contraseñas, formación en buenas prácticas y respuesta ante incidentes.',
  },
  {
    icon: 'fas fa-cloud',
    titulo: 'Soluciones en la Nube',
    descripcion:
      'Configuración de servicios en la nube como Google Workspace, Microsoft 365, almacenamiento en la nube, sincronización de archivos, copias de seguridad automáticas y migración de datos a plataformas cloud.',
  },
  {
    icon: 'fas fa-gamepad',
    titulo: 'Configuración de Equipos para Gaming y Streaming',
    descripcion:
      'Montaje y optimización de PCs gamer y estaciones para streaming. Instalación y configuración de OBS, periféricos, overlays, mejoras de FPS y consejos para obtener el mejor rendimiento en plataformas como Twitch o YouTube.',
  },
];

export default function Servicios() {
  return (
    <div className="page-wrapper">
      <main className="servicios-container contenido-box">
        <h1>Nuestros Servicios</h1>
        <div className="cards-grid">
          {servicios.map(({ icon, titulo, descripcion }) => (
            <div key={titulo} className="card">
              <i className={icon + ' card-icon'} aria-hidden="true"></i>
              <h3>{titulo}</h3>
              <p>{descripcion}</p>
            </div>
          ))}
        </div>

        {/* Aquí va la animación de contacto copiada exacta del Inicio.jsx */}
        <motion.section 
          className="seccion contacto-cta delay-7" 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6, delay: 1.2 }}
          style={{ marginTop: '5rem', textAlign: 'center' }}
        >
          <h2 className="titulo-izquierda">¿Tienes un problema? ¡Pregunta sin compromiso!</h2>
          <button 
            onClick={() => window.location.href = '/contacto'}
            style={{
              backgroundColor: '#004aad',
              color: '#fff',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              fontSize: '1.1rem',
              cursor: 'pointer',
              marginTop: '1rem'
            }}
          >
            Contactar
          </button>
        </motion.section>
      </main>
    </div>
  );
}
